import DataTable from 'components/datatable';
import { resetWorkItem, updateApplicantAction, updateLessonVisibilityAction } from 'ducks/workItem';
import { showModal } from 'ducks/modal';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import hasRole from 'util/hasRole';
import PreviousLink from '../PreviousLink';
import ApplicantSummary from './ApplicantSummary';
import {Badge, Box, Flex} from "rebass";
import styled from 'styled-components';
import {Translate} from "react-redux-i18n";
import { matchCourse } from '../../util/SearchUtil';

const PvBadgeHighlight = styled(Badge)`
  transition: background-color .5s ease;
  cursor: pointer;
  background-color: ${props => {if (!!props.selected) {
  return props.theme.colors.green;}
  return props.theme.colors.grays[0]}}
`;

const filterVisibleLessons = (lessonEntry, courseLessonIds, props) => {
  const { showCompulsory, showAdditional, showCurrentCourse } = props;
  const { lesson } = lessonEntry;
  return (
    (!showCurrentCourse || courseLessonIds.has(lesson.lessonId)) &&
    ((showCompulsory && !lesson.additionalLesson) ||
    (showAdditional && !!lesson.additionalLesson))
  );
};

class SelectedApplicant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stickyPrev: false
    };
    this.prevLink = React.createRef();

    const updateState = (newState) => {
      this.setState(Object.assign(this.state, newState));
    };

    const updateApplicantFn = (id) => {
      this.props.updateApplicant(id, Object.assign({}, this.state, {course: this.props.currentCourse}));
    };

    const showDriverCard = () => {
      const modalProps = {
        applicant: this.props.applicant
      };
      this.props.showDriverCardModal(modalProps);
    }

    this.updateState = updateState.bind(this);
    this.updateApplicantFn = updateApplicantFn.bind(this);
    this.scrollListener = this.scrollListener.bind(this);
    this.showDriverCard = showDriverCard.bind(this);
  }

  scrollListener(e) {
    const shouldBeSticky = e.target.scrollingElement.scrollTop >= this.state.stickyPrevOriginalPos;
    if (shouldBeSticky && (this.state.stickyPrev !== shouldBeSticky)) {
      this.setState({
        stickyPrev: shouldBeSticky
      })
    } else if (!shouldBeSticky && (this.state.stickyPrev !== shouldBeSticky)) {
      this.setState({
        stickyPrev: shouldBeSticky
      })
    }
  }

  componentDidMount() {
    const domNode = ReactDOM.findDOMNode(this.prevLink.current);
    this.setState({
      stickyPrevOriginalPos: domNode.offsetTop + 34 // Previous link initial position + username bar
    });
    window.addEventListener('scroll', this.scrollListener);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollListener);
    this.props.resetWorkItem();
  }

  render() {
    const {applicant, previousFn, loading, loggedUser, error, success, currentCourse, showProColumns} = this.props;
    
    const enableBtn = (this.state.hasOwnProperty('independentHandlingExamPerm') && this.state.independentHandlingExamPerm !== applicant.independentHandlingExamPerm)
      || (this.state.hasOwnProperty('personTransportPerm') && this.state.personTransportPerm !== applicant.personTransportPerm)
      || (this.state.hasOwnProperty('applicantStatus') && this.state.applicantStatus !== applicant.applicantStatus);
    const allApplicantLessons = (applicant.applicantLessons || []);
    const activeLessons = allApplicantLessons.filter(al => al.status === 'ACTIVE').map(al => al.lesson);
    const activeExamClasses = [...new Set(activeLessons.map(l => l.examClass))];
    const courseApplicantLessons = allApplicantLessons.filter(lesson => matchCourse(currentCourse)(lesson.course));
    const courseApplicantLessonIds = new Set(courseApplicantLessons.map(al => al.lesson.lessonId));


    return (
      <React.Fragment>
        <PreviousLink isSticky={this.state.stickyPrev} mb={2} previousFn={previousFn} previousText='action.back' ref={this.prevLink} />
        <ApplicantSummary
          applicant={applicant}
          isTeacher={hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA'])}
          isAdmin={hasRole(loggedUser, ['KULTU_ADMIN'])}
          disableUpdateBtn={!enableBtn && !loading}
          previousFn={previousFn}
          updateApplicantFn={this.updateApplicantFn}
          updateState={this.updateState}
          showDriverCard={this.showDriverCard}
          loading={loading}
          success={success}
          error={error}
          mt={this.state.stickyPrev && '50px'}
          currentCourse={currentCourse} />
        {!!applicant.lessonEntries && applicant.lessonEntries.length > 0 &&
        <Flex flexWrap='wrap'>
          <Box mt={2} width={'100%'} >
            <PvBadgeHighlight selected={this.props.showCompulsory} mb={1} bg='grays.0'
                              onClick = {() => this.props.updateLessonVisibility({showCompulsory: !this.props.showCompulsory})}><Translate value='datatable.compulsory_lessons'/></PvBadgeHighlight>
            <PvBadgeHighlight selected={this.props.showAdditional} mb={1} bg='grays.0'
                              onClick = {() => this.props.updateLessonVisibility({showAdditional: !this.props.showAdditional})}><Translate value='datatable.additional_lessons' /></PvBadgeHighlight>
            <PvBadgeHighlight selected={this.props.showCurrentCourse} mb={1} bg='grays.0'
                              onClick = {() => this.props.updateLessonVisibility({showCurrentCourse: !this.props.showCurrentCourse})}><Translate value='datatable.course_lessons' /></PvBadgeHighlight>
          </Box>
          <DataTable
            activeLessons={activeLessons}
            activeExamClasses={activeExamClasses}
            isTeacher={hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA'])}
            tableHeight='50vh'
            applicantNameAndTrafiId={`${applicant.lastName}, ${applicant.firstNames} (${applicant.trafiId})`}
            rowKey='entityId'
            rows={applicant.lessonEntries.filter(le => filterVisibleLessons(le, courseApplicantLessonIds, this.props))}
            tableType='LESSON_ENTRIES'
            showProColumns={showProColumns}
          />
        </Flex>
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    applicantId: state.workItem.selectedApplicant.applicant.entityId,
    success: state.workItem.success,
    loggedUser: state.userState.user,
    currentCourse: state.workItem.selectedApplicant.course || state.userState.currentCourse,
    showCompulsory: state.workItem.lessonVisibility.showCompulsory,
    showAdditional: state.workItem.lessonVisibility.showAdditional,
    showCurrentCourse: state.workItem.lessonVisibility.showCurrentCourse,
    showProColumns: !state.workItem.lessonVisibility.showCurrentCourse || state.userState.courseData.proCourse,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  updateApplicant: (applicantId, payload) => updateApplicantAction(applicantId, payload),
  resetWorkItem: () => resetWorkItem(),
  updateLessonVisibility: (visibility) => updateLessonVisibilityAction(visibility),
  showDriverCardModal: (modalProps) => showModal('DRIVER_CARD_ENTRY', modalProps),
}, dispatch);

SelectedApplicant.propTypes = {
  applicant: PropTypes.object,
  previousFn: PropTypes.func,
  refreshList: PropTypes.func,
  updateApplicant: PropTypes.func,
  error: PropTypes.object,
  loading: PropTypes.bool,
  loggedUser: PropTypes.object,
  currentCourse: PropTypes.object,
  success: PropTypes.bool,
  resetWorkItem: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectedApplicant);


// WEBPACK FOOTER //
// ./src/components/applicant/SelectedApplicant.jsx